import React from 'react';

import { Icon, IconSize } from '../Icon';
import * as S from './imageContainer.styles';
import { ImageContainerProps } from './imageContainer.types';

import WarningIcon from '@/icons/warning.icon.svg';

export const ImageContainer: React.FC<ImageContainerProps> = ({ name, image, warning = false }) => {
  return (
    <S.Container>
      <S.Wrapper>
        <img alt={name} src={image} />
        {warning && (
          <S.Warning>
            <Icon icon={WarningIcon} size={IconSize.S} />
          </S.Warning>
        )}
      </S.Wrapper>
    </S.Container>
  );
};
